/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { order } from "../../../../api/Api";

export const getAllDemand = createAsyncThunk(
  "appDemand/getAllDemand",
  async (query) => {
    try {
      return order.getAllDemand(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getDemand = createAsyncThunk("appDemand/getDemand", async () => {
  try {
    return order.getDemand();
  } catch (error) {
    console.error(error);
  }
});

export const appDemandSlice = createSlice({
  name: "appDemand",
  initialState: {
    demand: [],
    isFetchedDemand: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllDemand.fulfilled, (state, action) => {
      state.demand = action.payload?.data?.data;
      state.isFetchedDemand = true;
    });
  },
});

export default appDemandSlice.reducer;
